import Page from '../page';
import HTMLTemplateHelper from '../../helpers/html-template-helper';

export default class TemplateListPage extends Page {
  constructor(protected body: JQuery<HTMLBodyElement>) {
    super();
    this.bindAddToCartStatusChange();
  }

  protected bindAddToCartStatusChange(): void {
    this.body.find('.add_to_cart_form').on('addToCartSuccess', (e) => this.handleAddToCartSuccess(e.target as HTMLFormElement));
  }

  // eslint-disable-next-line class-methods-use-this
  protected handleAddToCartSuccess(form: HTMLFormElement): void {
    const statusContainer = $(form).closest('tr').find('.js-statusLabel');
    statusContainer.html(HTMLTemplateHelper.createStatusLabel({ statusCode: 'IN_CART' }).outerHTML);
    statusContainer.data('sort', 'IN_CART');
  }
}
